.root {
  display: grid;
  gap: 40px;
}

.pressReleaseRoot {
  @container press-release-root (min-width:1024px) {
    gap: 56px;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    gap: 56px;
  }
}
